import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable } from 'rxjs';
import { DipStateService } from '../services/dip-state-service.service';
import { TogetherDIPStageContainer } from 'app/models/app.models';

@Component({
  selector: 'together-auction-dip-jwt-redirect',
  templateUrl: './jwt-redirect.component.html',
  styleUrl: './jwt-redirect.component.scss',
  providers: [NodeAPIEntityService],
  standalone: false
})
export class JwtRedirectComponent implements OnInit {
  /**
     * The current stage
     * 
     * @type {TogetherDIPStageContainer}
     * @memberof ApplicationOverviewComponent
     */
  @Input() stage: TogetherDIPStageContainer;
  
  jwtHelper = new JwtHelperService();
  _isLoading: boolean = true;

  // Make sure we don't break retrieval
  initLocalStorage(params: object) {
    return new Observable((reqObs) => {
      window.sessionStorage.setItem('dipDetails', JSON.stringify(params));
      reqObs.next(true);
    });
  }

  /**
   * Stores the params in state.
   *
   * @param {any} params
   * @memberof JwtRedirectComponent
   */
  storeState(params, nextstage) {
    const state = {
      caseId: params.case_id,
      stageName: nextstage,
      propertyType: params.property_type,
      isDipJourney: params.is_dip,
    };
    this.initLocalStorage(state).subscribe(() => { });
  }

  _decodeValidJWT(jwt, nextstage) {
    try {
      const decoded_token = this.jwtHelper.decodeToken(jwt);
      this.state.caseId.next(decoded_token.case_id);
      this.storeState(decoded_token, nextstage);
      this.router.navigate(['dip',
        nextstage,
        decoded_token.case_id,
        decoded_token.property_type,
        decoded_token.is_dip]);
      
    } catch (JSONParseError) {
      this.state.loginFailed = true;
      this.router.navigate(['dip', 'tad_stage_info']); 
    }
  }

  _handleJWT(jwt, nextstage) {
    this.entity.verifyJWT(jwt)
      .subscribe(
        (success) => {
          const result = (success as any).Valid;
          if(result){
          this._decodeValidJWT(jwt, nextstage);
          this._isLoading = false;  
          }
          else{
            this.redirectToInfo();
          }
        },
        (error) => {
          this.redirectToInfo();
        },
      );
  }

  private redirectToInfo() {
    this.state.loginFailed = true;
    this.router.navigate(['dip', 'tad_stage_info']);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this._handleJWT(params.jwt, params.nextstage);
    });
  }

  constructor(private router: Router, 
    private route: ActivatedRoute, 
    private entity: NodeAPIEntityService, 
    private state: DipStateService)
  {

  }

}
